<template>
  <div module-item :class="info.type">
    <div class="left">
      <video loop muted autoplay playsinline :src="`${cdnHost}/${info.value.left.pc}`" class="hidden-ml-down"/>
      <video loop muted autoplay playsinline :src="`${cdnHost}/${info.value.left.mobile}`" class="hidden-tp-up"/>
    </div>
    <div class="right">
      <video loop muted autoplay playsinline :src="`${cdnHost}/${info.value.right.pc}`" class="hidden-ml-down"/>
      <video loop muted autoplay playsinline :src="`${cdnHost}/${info.value.right.mobile}`" class="hidden-tp-up"/>
    </div>
    <div class="desc" v-if="info.value.desc" v-html="enterToBr(info.value.desc)"></div>
  </div>
</template>

<script>

export default {
  name: 'DoubleVideo',
  props: ['value'],
  computed: {
    info() {
      return this.value;
    },
  },
};
</script>

